import {useState, useRef} from "react";
import Form, {ButtonItem, GroupItem, RequiredRule, SimpleItem} from "devextreme-react/form";
import {useSnackbar} from "notistack";
import {CheckBox} from 'devextreme-react/check-box';
import {db} from "../../../../firebase/Firebase";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {FormContainer, Layout, LayoutChild} from "../../../../palette/Palette";
import HeaderPage from "../../../../palette/HeaderPage";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import NumberBox from 'devextreme-react/number-box'
import './settings.css'
import {Button} from "devextreme-react/button";
import VerticalSpace from "../../../../palette/VerticalSpace";
import Alerts from "../../../../palette/Alerts";
import {Filters, UpdateArray} from "../../../../utils/HelpFunctions";
import Text from "../../../../palette/Text";
import {Element} from 'react-scroll'
import {fastScrollTo, scrollTo} from "../../../../utils/Scroll";

const state = [{ID: 1, state: 'Activo'}, {ID: 2, state: 'Inactivo'}]

const typeVehicle = {
    typeVehicle: '',
    description: '',
    numberSeats: null,
    numberParcels: null,
    valueAdded: null,
    state: '',
    rows: null,
    columns: null,
}

function VehicleTypeManagementForm(props) {

    const {trigger, setTrigger, DataStore, setVisibleForm, setVisibleGrid} = props

    const {companyName, idCompany,} = DataStore

    const [submitButton, setSubmitButton] = useState({...buttonSuccess, text: 'Crear vehículo'})
    const [load, setLoad] = useState(true)
    const [textLoad, setTextLoad] = useState('Cargando...')
    const [seating, setSeating] = useState([])
    const [alert, setAlert] = useState(false)
    const [rowsColumns, setRowsColumns] = useState({rows: null, columns: null})
    const [rowsColumnsAlert, setRowsColumnsAlert] = useState(false)
    const [selectSeats, setSelectSeats] = useState(true)
    const [completeSelect, setCompleteSelect] = useState(false)
    const [success, setSuccess] = useState(false)

    const {enqueueSnackbar} = useSnackbar();
    const dxForm = useRef(null);

    const renderCancelButton = () => {
        const {instance} = dxForm.current
        return (
            <Button id="cancel-button"
                    icon="fas fa-ban"
                    text="Cancelar"
                    onClick={() => {
                        instance.resetValues()
                        setVisibleForm(false)
                        setVisibleGrid(true)
                    }}/>
        )
    }

    const onClickGenerate = () => {
        if (rowsColumns.rows && rowsColumns.columns) {
            setRowsColumnsAlert(false)
            const rows = rowsColumns.rows
            const columns = rowsColumns.columns
            let c = 0
            let r = []
            let matrix = []
            let setData = {}
            for (let i = 0; i < rows; i++) {
                for (let j = 0; j < columns; j++) {
                    c = c + 1
                    setData = {
                        description: c === 1 ? `Chofer` : `Asiento ${c}`,
                        value: c === 1,
                        reservation: false,
                        id: ''
                    }
                    r.push(setData)
                    if (r.length === columns) {
                        matrix.push(r)
                        setData = {}
                        r = []
                    }
                }
            }
            setSeating(matrix)
            fastScrollTo('bottom-element')
        } else {
            setRowsColumnsAlert(true)
        }
    }

    const onValueChangedRowsColumns = (value, key) => {
        setRowsColumns({...rowsColumns, [key]: value})
    }

    const renderRowsColumns = () => {
        return (
            <>
                <Layout row center space>
                    <div className="dx-field">
                        <div className="dx-field-label">Filas*</div>
                        <div className="dx-field-value">
                            <NumberBox value={rowsColumns.rows} max={25} min={1}
                                       onValueChanged={(e) => onValueChangedRowsColumns(e.value, 'rows')}>
                                <RequiredRule message="Ingrese las filas"/>
                            </NumberBox>
                        </div>
                    </div>
                    <div className="dx-field">
                        <div className="dx-field-label">Columnas*</div>
                        <div className="dx-field-value">
                            <NumberBox value={rowsColumns.columns} max={6} min={1}
                                       onValueChanged={(e) => onValueChangedRowsColumns(e.value, 'columns')}>
                                <RequiredRule message="Ingrese las columnas"/>
                            </NumberBox>
                        </div>
                    </div>

                    <Button
                        icon="fas fa-th"
                        elementAttr={{id: 'generate-seats-button'}}
                        text="Generar"
                        onClick={onClickGenerate}/>
                </Layout>
                <VerticalSpace space={7}/>
                {rowsColumnsAlert && <Alerts severity={'error'} body={'Ingrese el número de filas o columnas'}/>}
            </>
        )
    }

    const onValueChanged = (key, i, e) => {
        fastScrollTo('bottom-element')
        let newDataArray = [...seating]
        if (typeVehicle.numberSeats) {
            setSelectSeats(true)
            newDataArray[i] = UpdateArray(newDataArray[i], 'description', key, 'value', e.value)
            setSeating(newDataArray)

            const newDataSeating = []

            newDataArray.forEach(items => {
                items.forEach(item => {
                    newDataSeating.push(item)
                })
            })

            const controlSeating = Filters(newDataSeating, 'value', true)

            if (controlSeating.length - 1 === typeVehicle.numberSeats) {
                setAlert(false)
                setCompleteSelect(true)
            } else {
                setAlert(true)
                setCompleteSelect(false)
            }
        } else {
            setSelectSeats(false)
        }
    }

    const renderScheme = () => {
        return (
            <Layout color={'transparent'}>
                {seating.map((items, i) => {
                    return (
                        <>
                            <VerticalSpace space={5}/>
                            <LayoutChild color={'#DCEDC8'} row space key={i} center padding={10} radius={10}
                                         percent={100} border={'2px solid #81C784'}>
                                <Text hover={false} text={`Fila ${i + 1}`} color={'#333'} weight={'bold'} size={14}/>
                                {items.map((item, index) => {
                                    return (
                                        <LayoutChild color={'blues'} row space padding={10} radius={20} key={index}>
                                            <CheckBox value={item.value} text={item.description}
                                                      elementAttr={{id: 'seating-checks'}}
                                                      disabled={item.description === 'Chofer'} style={{marginTop: 15}}
                                                      onValueChanged={(e) => onValueChanged(item.description, i, e)}/>
                                        </LayoutChild>
                                    )
                                })}
                            </LayoutChild>
                        </>
                    )
                })}
                <div style={{marginTop: 5}}/>
                {(alert && selectSeats) &&
                <Alerts severity="warning" body={`Debe seleccionar ${typeVehicle.numberSeats} asientos`}/>}
                {!selectSeats &&
                <Alerts severity="error" body={`Ingrese el número de asientos`}/>}
                {(completeSelect && selectSeats) && <Alerts severity="success" body={'Selección completa.'}/>}
            </Layout>
        )
    }

    const renderComplete = () => {
        return (<Alerts severity="success" body={'Vehículo creado exitosamente'}/>
        )
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newDataSeating = []
        setCompleteSelect(false)
        seating.forEach(items => {
            items.forEach(item => {
                newDataSeating.push(item)
            })
        })

        const {instance} = dxForm.current
        setLoad(false)
        setTextLoad('Guardando...')

        const controlSeating = Filters(newDataSeating, 'value', true)

        if (controlSeating.length - 1 === typeVehicle.numberSeats) {
            setSubmitButton({...submitButton, text: 'Guardando...', icon: 'fa fa-spinner fa-spi', disabled: true})
            setAlert(false)

            const newData = {
                ...typeVehicle,
                seating: newDataSeating,
                rows: rowsColumns.rows,
                columns: rowsColumns.columns
            }

            fastScrollTo('top-element')

            await db.collection(companyName).doc(idCompany).collection('TypesVehicles')
                .doc().set(newData)
                .then(() => {
                    setTrigger(!trigger)
                    setSuccess(true)
                    scrollTo('bottom-element')
                    setTimeout(() => {
                        instance.resetValues()
                        setVisibleForm(false)
                        setVisibleGrid(true)
                        setLoad(true)
                        setTextLoad('Cargando...')
                        setSuccess(false)
                        setSeating([])
                        setSubmitButton({
                            ...submitButton,
                            icon: 'far fa-check-circle',
                            text: 'Crear vehículo',
                            disabled: false
                        })
                    }, 2500)
                }).catch(() => {
                    setSeating([])
                    NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                    setSubmitButton({
                        ...submitButton,
                        icon: 'far fa-check-circle',
                        text: 'Crear vehículo',
                        disabled: false
                    })
                })

        } else {
            setAlert(true)
        }
    }

    return (
        <>
            <Element name="top-element" className="element"/>
            <div className="vehicle-type-form-container">
                <HeaderPage icon={'fas fa-car'} text={'Crear tipo de vehículo'} load={load}
                            textLoad={textLoad}/>
                <FormContainer>
                    <form action="" onSubmit={handleSubmit}>
                        <Form
                            ref={dxForm}
                            formData={typeVehicle}
                            readOnly={false}
                            showColonAfterLabel={true}
                            validationGroup="create-vehicle"
                            colCount={1}
                        >
                            <GroupItem caption={'Datos'} colCount={1}>
                                <SimpleItem dataField="typeVehicle" label={{text: 'Tipo de vehículo'}}
                                            editorOptions={{maxLength: 50}}>
                                    <RequiredRule message="Ingrese el tipo de vehículo"/>
                                </SimpleItem>
                                <SimpleItem dataField="description" label={{text: 'Descripción'}}
                                            editorOptions={{maxLength: 50}}>
                                    <RequiredRule message="Ingrese una descripcion"/>
                                </SimpleItem>

                                <SimpleItem dataField="numberSeats" label={{text: 'Número de asientos'}}
                                            editorOptions={{min: 1, max: 20}}
                                            editorType="dxNumberBox">
                                    <RequiredRule message="Ingrese el número de asientos"/>
                                </SimpleItem>

                                <SimpleItem dataField="numberParcels" label={{text: 'Número de encomiendas'}}
                                            editorOptions={{min: 0, max: 100}}
                                            editorType="dxNumberBox">
                                    <RequiredRule message="Ingrese el número de encomiendas"/>
                                </SimpleItem>

                                <SimpleItem dataField="valueAdded" label={{text: 'Valor agregado'}}
                                            editorType="dxNumberBox"
                                            editorOptions={{format: "$ #,##0.##", min: 0}}>
                                    <RequiredRule message="Ingrese un valor"/>
                                </SimpleItem>

                                <SimpleItem dataField="state" label={{text: 'Estado'}} editorType="dxSelectBox"
                                            editorOptions={{
                                                dataSource: state,
                                                displayExpr: "state",
                                                valueExpr: "state",
                                                searchEnabled: true,
                                                placeholder: 'Seleccionar...'
                                            }}>
                                    <RequiredRule message="Seleccione el estado"/>
                                </SimpleItem>
                            </GroupItem>

                            <GroupItem caption="Esquema del vehículo" colCount={1}>
                                <SimpleItem render={renderRowsColumns}/>
                                <SimpleItem render={renderScheme}/>
                                {success && <SimpleItem render={renderComplete}/>}
                            </GroupItem>
                            <GroupItem colCount={2}>
                                <SimpleItem render={renderCancelButton}/>
                                <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                            </GroupItem>
                        </Form>
                    </form>
                </FormContainer>
                <Element name="bottom-element" className="element"/>
            </div>
            <VerticalSpace space={30}/>
        </>
    )
}

export default VehicleTypeManagementForm
